<template>
  <div>
    <BannerInscrevase/>
    <FormularioInscrevase/>
  </div>
</template>

<script>
import BannerInscrevase from '@/wrappers/BannerInscrevase'
import FormularioInscrevase from '@/wrappers/FormularioInscrevase'

export default {
  name: 'Inscrevase',
  components: {
    BannerInscrevase,
    FormularioInscrevase,
  }
}
</script>

